import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { NewInspectionService } from '../../../../inpsection.service';
import {
    InspectionObservationPointsViewModel,
    PhotoModelComingFrom,
    CommentModelComingFrom,
    QuestionModelComingFrom,
    InspectedComponentsOnImplementViewModel,
    ComponentTypes,
    InspectionCompTypeCompObsPoints,
    ObservationImagesViewModel
} from '../../../../inspection.model';
import { DomSanitizer } from '@angular/platform-browser';
import { ObservationQuestionsComponent } from '../observation-questions/observation-questions.component';
import { MatDialog } from '@angular/material/dialog';
import { NotificationsService } from 'angular2-notifications';
import { GETPreferencesService } from '../../../../../../../modules/GET_NEW_UI/preferences/preferences.service';
import { ComponentVM } from '../../../../../setup-implement/setup-implement.model';
import { SchematicAndObservationPointDetails, SchematicDetails } from '../../../../../equipment-details/equipment-details.model';
import { AddCrackObsPointDialogComponent } from '../../../../../add-crack-obs-point-dialog/add-crack-obs-point-dialog.component';
import { ObservationPointVM } from '../../../../../favourite-dialog/favourite-dialog-modal';
import { ImplementDetailsService } from '../../../../../implement-details/implement-details.service';
import { SetupImplementService } from '../../../../../setup-implement/setup-implement.service';
import { GETViewPhotoComponent } from '../../../../../shared/view-photo/view-photo.component';
import { ModuleType } from '../../../../../../../shared/enums/allEnums';


@Component({
  selector: 'app-view-componenttype-points',
    templateUrl: './view-componenttype-points.component.html',
    styleUrls: ['./view-componenttype-points.component.scss'],
    animations: [
        trigger(
            'fadeIn', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('500ms', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate('500ms', style({ opacity: 0 }))
            ])
        ]
        )]
})
export class ViewComponentTypePointsComponent implements OnInit {

  @Input() observations: InspectionCompTypeCompObsPoints[] = [];
  @Input() SchematicId: number;
    @Input() GETComponentTypeId: number;
    @Input() implementID: number = 0;
    @Input() implementInspectionId: number = 0;
    @Input() inspectionDate: Date;
  @Input() Residual: number;
  @Input() index!: number;

  @Output() loaded: EventEmitter<boolean> = new EventEmitter();

    photoComingFrom = PhotoModelComingFrom.InterpretationObservationPointImageOnComponentLevel;
    commentComingFrom = CommentModelComingFrom.Interpretation;
    loadingRow = true;
    openingEditPopup = false;
    userPref: string;
    showPopup: boolean = false;
    showQPopup: boolean = false;
    componentList: ComponentVM[];
    components: InspectedComponentsOnImplementViewModel[];
   // componentTypes: ComponentTypes[];
  currentQuestion: string;
  questionInstruction: string;
  questionImage: string;
  ModuleType = ModuleType;

    constructor(
        private _inspectionService: NewInspectionService,
        private _sanitizer: DomSanitizer,
        private _dialog: MatDialog,
        private _toaster: NotificationsService,
        public _getPrefrencesService: GETPreferencesService,
      private _moduleService: ImplementDetailsService,
      private _implementService: SetupImplementService
    ) { }

    ngOnInit() {
        // this.loadingRow=true;
        this.getUserPref();
        //this.loadData();
    }

  //ngAfterViewInit() {
  //  this.loadingRow = false;
  //}
    //ngAfterViewChecked() {
    //    if (!this.loadingRow && !this.emitted) {
    //        this.emitted = true;

    //        setTimeout(() => {
    //            this.loadDone.emit();
    //        });
    //    }
    //}

    //ngOnChanges(changes: SimpleChanges) {
    //    if (changes['GETComponentTypeId'] && this.GETComponentTypeId) {
    //        this.loadData();
    //    }
    //}


    loadData() {
        //this.loadingRow = true;
      this._inspectionService.GetAllObservationPointsByCompType(this.SchematicId, this.GETComponentTypeId, this.implementInspectionId).subscribe(r => {
            this.observations = r;
            //this.componentTypes = this.getDistinctComponentTypes(this.observations);
            //console.log("observations:, this.componentTypes", this.observations, this.componentTypes);
            
            if (this.observations?.length > 0) {
                this.observations.forEach(obs => {
                   


                  obs.ObservationMeasurements= obs.ObservationMeasurementsJson
                    ? JSON.parse(obs.ObservationMeasurementsJson)
                    : []
                  //console.log("obs.ObservationMeasurements", obs.ObservationMeasurements);

                  obs.ObsList = obs.ObsListJson
                    ? JSON.parse(obs.ObsListJson)
                    : []

                  obs.obsSeverityList = obs.ObsSeverityJson
                    ? JSON.parse(obs.ObsSeverityJson)
                    : []


                  obs.ObservationImages =
                    obs.ObservationImagesJson
                      ? JSON.parse(obs.ObservationImagesJson)
                      : [];

                  obs.severityIDs =
                    obs.SeverityIDsJson
                    ? JSON.parse(obs.SeverityIDsJson)
                      : [];

                  if (obs?.ObsList?.length > 0 && obs?.ObservationTypeName === 'Crack') {
                    obs.obsId = obs.severityIDs?.[0] ?? null;
                  }


                });
          }
          
        });
    }


    //getDistinctComponentTypes(data: any[]) {
    //    if (!data || data.length === 0) return [];

    //    const typeMap = new Map<number, any>();

    //    for (const r of data) {
    //        if (!typeMap.has(r.ComponentTypeId)) {
    //            typeMap.set(r.ComponentTypeId, {
    //                ComponentTypeId: r.ComponentTypeId,
    //                ComponentTypeName: r.ComponentTypeName,
    //                SchematicId: r.SchematicId,
    //                SchematicName: r.SchematicName,
    //                SchematicPath: r.SchematicPath,
    //                CompTypeComment: r.CompTypeComment,
    //                ReportOptionId: r.ReportOptionId,
    //                CompTypeLife: r.CompTypeLife,
    //                CompTypeResidual: r.CompTypeResidual,
    //                CompTypeWorn: r.CompTypeWorn,
    //                SchematicOrder: r.SchematicOrder
    //            });
    //        }
    //    }

    //    // Return array of unique component types
    //    return Array.from(typeMap.values());
    //}

    getObservationsByType(componentTypeId: number) {
        return this.observations?.filter(
            x => x.ComponentTypeId === componentTypeId
        );
    }


      ToggleObsFlag(ObservationInspectionId:number,flag:boolean){
        if (ObservationInspectionId>0){
          this._inspectionService.UpdateObservationInspectionFlag(ObservationInspectionId,flag).subscribe(r=>{
            if (r.m_Item1) {
              this._toaster.success(r.m_Item2);
              //this.loadData();
              const obs = this.observations.find(o => o.Id === ObservationInspectionId);
              if (obs) {
                obs.Flag = flag;
              }
          } else {
              this._toaster.error(r.m_Item2);
          }
          })
        }
      }

  DeleteObsMeasurement(ObservationInspection: InspectionCompTypeCompObsPoints){
        if(ObservationInspection.Id>0){
    //check reading ID
    let ObsMeasurementReadiingId = ObservationInspection.ObservationMeasurements[0].Id;

          this._inspectionService.RemoveObservationMeasurment(ObsMeasurementReadiingId).subscribe(r=>{
            if (r.m_Item1) {
              this._toaster.success(r.m_Item2);
              this.loadData();
          } else {
              this._toaster.error(r.m_Item2);
          }
          })
        }
      }

    toggleObservationPointIncludeReport(ObservationId: number) {
        if (ObservationId > 0) {
            this._inspectionService.toggleObservationInspectionIncludeReport(ObservationId).subscribe((r: any) => {
                if (r.m_Item1) {
                    this._toaster.success(r.m_Item2);
                } else {
                    this._toaster.error(r.m_Item2);
                }
            });
        }
    }

    getImage(image: string) {
        if (image != null && image !== undefined) {
            return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
        }
    }
    getEvalClass(worn: number) {
        return this._inspectionService.getEvalClass(worn);
    }
    getEvalClass2(worn: number) {
        return this._inspectionService.getEvalClass2(worn);
    }

  getEvalCode(value: number): string {
    return this._inspectionService.getEvalCode2(value);
        //if (value == 15) return 'A';
        //if (value == 45) return 'B';
        //if (value == 70) return 'C';
        //if (value == 85) return 'X';
        //if (value == 0) return 'U';
    }

    //photoRecevied(image, ObservationPoint: InspectionObservationPointsViewModel) {
    //  // const newPhoto = new ObservationImagesViewModel(image);
    //  // if (ObservationPoint.ObservationImages !== undefined) {
    //  //   ObservationPoint.ObservationImages.push(newPhoto);
    //  // }    else {
    //  //   ObservationPoint.ObservationImages = [];
    //  //   ObservationPoint.ObservationImages.push(newPhoto);
    //  // }
    //  this.loadData()
    //}

    photoRecevied(image, ObservationPoint: InspectionCompTypeCompObsPoints) {
      // const newPhoto = new ObservationImagesViewModel(image);
       if (ObservationPoint.ObservationImages !== undefined) {
         ObservationPoint.ObservationImages.push(image);
       }    else {
         ObservationPoint.ObservationImages = [];
         ObservationPoint.ObservationImages.push(image);
       }
    }

  obsCommentChanged(comment, ObservationPoint: InspectionCompTypeCompObsPoints) {
    // console.log(comment);
    ObservationPoint.Comments = comment;
    }

  //commentChanged(Id: number, value: any) {
  //  this._inspectionService.UpdateReportSummaryComment(Id, value).subscribe((r: any) => {
  //    if (r.m_Item1) {
  //      this._toaster.success(r.m_Item2);
  //    } else {
  //      this._toaster.error(r.m_Item2);
  //    }
  //  });
  //}

    measurementChanged(event) {
      //console.log(event);

      if (event) {
        this.loadData();
      }
    }


  viewObservationImages(image: ObservationImagesViewModel, ObservationPoint: InspectionCompTypeCompObsPoints) {
      const passingData = {
            comingFrom: PhotoModelComingFrom.InterpretationObservationPointImageOnComponentLevel,
        inspectionObservationPoint: ObservationPoint,
        image: image,
        ImageUrl: true
      };
      //console.log('passingData',passingData)

      const viewCommentModalRef = this._dialog.open(GETViewPhotoComponent, {
        width: '1032px',
        data: passingData,

      });
      viewCommentModalRef.afterClosed().subscribe(changes => {
        if (changes) {
          this.loadData();
        }
      });
    }

    shouldHighlight(ObservationPoint: InspectionCompTypeCompObsPoints): boolean {
        if (ObservationPoint.QuestionTitle === undefined || ObservationPoint.QuestionTitle === null || ObservationPoint.QuestionTitle.length == 0) {
            return false;
        }
        return true;
    }

    shouldHighlightQandI(ObservationPoint: InspectionCompTypeCompObsPoints): boolean {
        if ((ObservationPoint.QuestionInstruction === undefined || ObservationPoint.QuestionInstruction === null || ObservationPoint.QuestionInstruction.length == 0) && (ObservationPoint.ImagePath == null))
            return false;
        return true;
    }

    getUserPref() {
        this._getPrefrencesService.getUserPreferences().subscribe(r => {
            this.userPref = r.UnitOfMeasurementName;
            //console.log("userPref", this.userPref);
        })
    }


    openObservationQuestions(ObservationPoint: InspectionCompTypeCompObsPoints) {
        const passingData = {
            comingFrom: QuestionModelComingFrom.Interpretation,
            observation: ObservationPoint,
        };

        const viewCommentModalRef = this._dialog.open(ObservationQuestionsComponent, {
            width: '1032px',
            data: passingData,
        });
        viewCommentModalRef.afterClosed().subscribe(changes => {
            if (changes) {
                // this.comment = reloadComment;
                // this.observationPoint.Comments = reloadComment;
                // this.onCommentChange.emit(reloadComment);
            }
        });
    }

    updateCrackSeverity(observationPointInspectionID, severityID) {
        this._inspectionService.UpdatCrackSeverityOnObservationPoint(observationPointInspectionID, severityID)
            .subscribe(a => {
                //console.log("aaaa",a);
                this._toaster.success("Severity updated Successfully.")
                //this._inspectionService.mySubject.next(true);
            });
    }

    updateObsSeverity(observationPointInspectionID, severityIDs) {
       // console.log("severityIDs:", severityIDs)
       // console.log("this.observations:", this.observations)
        const severityIdArray = Array.isArray(severityIDs) ? severityIDs : severityIDs != null ? [severityIDs] : [];
        this._inspectionService.UpdatObsSeveritiesOnObservationPoint(observationPointInspectionID, severityIdArray).subscribe(a => {
            //console.log("aaaa",a);
            if (a > 0) {
                this._toaster.success("Obs list updated Successfully.")
                //this._inspectionService.mySubject.next(true);
            }
            else
                this._toaster.error("Failed to update.")
        });
    }

  openPopup(questionInstruction: string, questionImage: string) {
    this.showPopup = true;
    this.questionInstruction = questionInstruction;
    //this.questionImage = this.getImageUrl(questionImage);
    this.questionImage = questionImage;
    //const byteArray = new Uint8Array(questionImage);
    //const blob = new Blob([byteArray], { type: 'image/png' });

    //this.questionImage = URL.createObjectURL(blob);
  }

    closePopup() {
      this.showPopup = false;
      this.questionInstruction = "";
      this.questionImage = "";
    }

    getImageUrl(image: string): any {
        if (!image) return null;

        const isDataUrl = image.startsWith('data:image');
        return isDataUrl ? image : this._sanitizer.bypassSecurityTrustUrl(`data:image/png;base64,${image}`);
    }

  openQPopup(questionTitle: string) {
      this.showQPopup = true;
    this.currentQuestion = questionTitle;
    }

    closeQPopup() {
      this.showQPopup = false;
      this.currentQuestion = "";
    }

  getMimeType(bytes: number[]): string {
    if (!bytes || bytes.length < 4) return 'image/jpeg';

    if (bytes[0] === 137 && bytes[1] === 80 && bytes[2] === 78 && bytes[3] === 71)
      return 'image/png';

    if (bytes[0] === 255 && bytes[1] === 216)
      return 'image/jpeg';

    if (bytes[0] === 71 && bytes[1] === 73 && bytes[2] === 70)
      return 'image/gif';

    return 'image/jpeg';
  }

  openSchematicWindow(observation: InspectionCompTypeCompObsPoints) {
      this.openingEditPopup = true;
      let arr_ = [];
      var SchematicImage = new SchematicAndObservationPointDetails();
      this._moduleService.getSchematicsObservationPointsDetails(this.implementID, observation.SchematicId).subscribe(details => {
        SchematicImage.ObservationPoints = details;
        // console.log("SchematicImage.ObservationPoints", SchematicImage.ObservationPoints);
        this._moduleService.getSchematicImageBaseString(observation.SchematicId).subscribe(r => {
          if (r) {
            if (!SchematicImage.Schematic) {
              SchematicImage.Schematic = new SchematicDetails();  // or {} if you don't have a class
            }
            SchematicImage.Schematic.Data = r;
          }
          this._implementService.ReturnGETSchematicComponents(this.implementID, observation.SchematicId).subscribe(result => {
            this.componentList = result
            //this.loadComponentList(SchematicImage.Schematic.Id);
            console.log("SchematicImage.ObservationPoints", SchematicImage.ObservationPoints);
            SchematicImage.ObservationPoints.map(x => {
              var neModl = new ObservationPointVM();
              neModl.ObservationPointId = x.Id;
              neModl.ObservationPointPosX = x.PositionX;
              neModl.ObservationPointPosY = x.PositionY;
              neModl.EndObservationPointPosX = x.EndPositionX;
              neModl.EndObservationPointPosY = x.EndPositionY;
              neModl.isCrackFixed = x.IsCrackFixed;
              neModl.ObservationPointName = x.Name;
              neModl.observationPointTypeId = x.ObPointTypeId;
              neModl.WornPct = x.WornPct;
              neModl.InspectionDate = x.InspectionDate;
              neModl.pointLedgend = 3;
              neModl.CrackStatusId = x.CrackStatusId;
              neModl.ColorCode = x.ColorCode;
              neModl.CrackStatus = x.CrackStatus;
              neModl.InstallDate = x.InstallDate;
              neModl.CurrentLength = Number((parseFloat(x.CurrentLength ?? '0') || 0).toFixed(1));
              arr_.push(neModl)
            });
            console.log("arr_", arr_);
            this.openingEditPopup = false;
            const addSectionDialog = this._dialog.open(AddCrackObsPointDialogComponent, {
              width: '1300px',
              //height: '1075px',
              disableClose: true,
              data: {
                obsDetails: arr_,
                schematic: SchematicImage.Schematic.Data,
                componentList: this.componentList,
                schematicId: SchematicImage.Schematic.Id,
                IsGETInspection: true,
                inspectionDate: this.inspectionDate,
                implementInspectionId: this.implementInspectionId,
                obsDetailExisting: observation
              }
            });
            addSectionDialog.afterClosed().subscribe(ObsID => {
              if (ObsID > 0) {
                      //console.log("details", ObsID)
                //this.loadImplementDetails();
                //      this.getInspectionComponents();
              } else {
              
              }
            });
          });
        });
      });
    }

  onOpened(opened: boolean) {
    if (!opened) return;
    setTimeout(() => {
      const pane = document.querySelector('.cdk-overlay-pane:last-child') as HTMLElement;
      if (!pane) return;
      const rect = pane.getBoundingClientRect();
      if (rect.bottom > window.innerHeight) {
        const overflow = rect.bottom - window.innerHeight + 20;
        pane.style.transform += ` translateY(-${overflow}px)`;
      }
    }, 50);
  }
}
